import { render, staticRenderFns } from "./BreadCrumbItem.vue?vue&type=template&id=3b33da9b&functional=true&"
import script from "./BreadCrumbItem.vue?vue&type=script&lang=ts&"
export * from "./BreadCrumbItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports